import { isDesktopQuery, getFeatureEnabled } from '@gig/magic-common';
import { USER_LOGGED_IN_UPDATED, GAMES_RECOMMENDED_GAMES_USER, Feature } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { DeviceType } from '@gig/magic-sdk/dist/adapter/games/getRecommendedGames';

var UserRecommendedGamesService = /** @class */ (function () {
    function UserRecommendedGamesService() {
        var _this = this;
        getFeatureEnabled(Feature.RECOMMENDED_GAMES_USER).then(function (enabled) {
            if (enabled) {
                _this.subscribeToUserLoggedInChanges();
            }
            else {
                window.eventBus.publish(GAMES_RECOMMENDED_GAMES_USER, []);
            }
        });
    }
    UserRecommendedGamesService.prototype.subscribeToUserLoggedInChanges = function () {
        var _this = this;
        window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var isDesktop, deviceType, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isDesktopQuery()];
                    case 1:
                        isDesktop = _a.sent();
                        deviceType = isDesktop
                            ? DeviceType.DESKTOP
                            : DeviceType.MOBILE;
                        if (!event.payload) return [3 /*break*/, 3];
                        return [4 /*yield*/, magic.methods.games.getRecommendedGames({
                                deviceType: deviceType,
                            })];
                    case 2:
                        payload = _a.sent();
                        window.eventBus.publish(GAMES_RECOMMENDED_GAMES_USER, payload);
                        return [3 /*break*/, 4];
                    case 3:
                        window.eventBus.publish(GAMES_RECOMMENDED_GAMES_USER, []);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    return UserRecommendedGamesService;
}());

export { UserRecommendedGamesService };
